import App from './App';
import React from 'react';
import { hydrate, render } from 'react-dom';
import { getClientByDomain, isDev, getParameterByName } from './helpers';

const clientCode =
	getParameterByName('client') ||
	getClientByDomain(window.location.hostname) ||
	'AOL';
const isPreview = getParameterByName('isPreview') ? true : false;

const windowObjectDefaultProps = {
	isEnabled: true
};

if (window && window.AOSearchWidget) {
	window.AOSearchWidget = {
		...window.AOSearchWidget,
		...windowObjectDefaultProps
	};
} else if (window) {
	window.AOSearchWidget = { ...windowObjectDefaultProps };
}
const APP = <App clientCode={clientCode.toUpperCase()} isPreview={isPreview} />;
const RENDER_EL = document.getElementById('search-root');

if(isDev) {
	render(APP, RENDER_EL);
} else {
	hydrate(APP, RENDER_EL);
}
